import { useEffect } from 'react';

import { Container, Flex, FloraButton } from '@grupoboticario/flora-react';
import {
  ClockIcon,
  EnvelopeClosedIcon,
  ExclamationMarkHexagonIcon,
  HouseIcon,
  RoundCircleClockIcon,
  PersonIcon,
} from '@grupoboticario/flora-react-icons';
import Cookies from 'js-cookie';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';
import { ptBRCadastralChangeName } from 'helpers';
import { useDrawer } from 'hooks';
import { ACCESS_TOKEN_KEY_CADASTRAL_CHANGE } from 'services/auth/constants';

import Styles from './MessageUpdateSuccess.styles';
import StylesDrawer from '../../../../Drawers.styles';

export const MessageUpdateSuccess = ({ type }: { type: string }) => {
  const hasChangeToken = Cookies.get(ACCESS_TOKEN_KEY_CADASTRAL_CHANGE);
  const textFormatted = `O ${ptBRCadastralChangeName[type]} ainda não foi atualizado no seu perfil.`;

  const { handleRedirectTo } = useDrawer('CadastralChange');

  useEffect(() => {
    if (!hasChangeToken) {
      clearTokenChangeCadastal();
      handleRedirectTo('/perfil');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasChangeToken]);

  const handleGoToProfile = () => {
    clearTokenChangeCadastal();
    window.location.replace('/perfil');
  };

  const goToHome = () => {
    clearTokenChangeCadastal();
    window.location.replace('/departamentos');
  };

  const clearTokenChangeCadastal = () => {
    Cookies.remove(ACCESS_TOKEN_KEY_CADASTRAL_CHANGE);
  };

  return (
    <StylesDrawer.DrawerSection direction='column' gap='$2'>
      <Container size='medium' data-autotagging-flora-section={`alterar_${type}`}>
        <Styles.Content direction='column' align='center' gap='$3'>
          <RoundCircleClockIcon color='$backgroundAltSecondary' size={47} />
          <ResponsiveFloraTypography
            color='$backgroundAltPrimary'
            fontSize='title'
            fontWeight='bold'
          >
            Solicitação em análise.
          </ResponsiveFloraTypography>
        </Styles.Content>
        <Styles.Content gap='$4' direction='column'>
          <Styles.WrapperList>
            <ExclamationMarkHexagonIcon size={32} color='$backgroundAltSecondary' />
            <ResponsiveFloraTypography
              fontSize='bodySmallShort'
              fontWeight='bold'
              color='$backgroundAltSecondary'
            >
              {textFormatted}
            </ResponsiveFloraTypography>
          </Styles.WrapperList>
          <Styles.WrapperList>
            <EnvelopeClosedIcon size={32} color='$backgroundAltSecondary' />
            <ResponsiveFloraTypography
              fontSize='bodySmallShort'
              fontWeight='bold'
              color='$backgroundAltSecondary'
            >
              Atualizações serão enviadas para o e-mail cadastrado no seu perfil.
            </ResponsiveFloraTypography>
          </Styles.WrapperList>
          <Styles.WrapperList>
            <ClockIcon size={32} color='$backgroundAltSecondary' />
            <ResponsiveFloraTypography
              fontSize='bodySmallShort'
              fontWeight='bold'
              color='$backgroundAltSecondary'
            >
              A alteração pode ocorrer em até 2 dias.
            </ResponsiveFloraTypography>
          </Styles.WrapperList>
        </Styles.Content>
        <Flex
          direction='column'
          css={{
            marginBottom: '$3',
          }}
        >
          <FloraButton
            autotagging-flora='on'
            data-flora='button'
            data-flora-text='ir-para-o-perfil'
            has='iconLeft'
            icon={<PersonIcon size='16' aria-hidden />}
            onClick={handleGoToProfile}
          >
            <ResponsiveFloraTypography fontWeight='bold'>
              Ir para o perfil
            </ResponsiveFloraTypography>
          </FloraButton>
        </Flex>
        <Flex direction='column'>
          <FloraButton
            autotagging-flora='on'
            data-flora='button'
            data-flora-text='ir-para-o-inicio'
            hierarchy='secondary'
            has='iconLeft'
            icon={<HouseIcon size='16' aria-hidden />}
            onClick={goToHome}
          >
            <ResponsiveFloraTypography fontWeight='bold'>
              Ir para o início
            </ResponsiveFloraTypography>
          </FloraButton>
        </Flex>
      </Container>
    </StylesDrawer.DrawerSection>
  );
};
